<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.87988 2.87988H21.1199V21.1199H2.87988V2.87988ZM19.5887 4.41108H4.41108V19.5863H19.5863V4.41108H19.5887ZM13.5311 15.0287V16.5599H6.69108V15.0287H13.5311ZM13.5311 11.2511V12.7463H6.69108V11.2511H13.5311ZM13.5311 7.43988V8.97108H6.69108V7.43988H13.5311Z"
      class="fill-current"
    />
    <path
      d="M18.2569 6.83515L17.6713 6.25195L16.0801 7.83595L15.4585 7.21195L14.8633 7.80715L16.0801 9.02155L18.2569 6.83515Z"
      class="fill-current"
    />
    <path
      d="M16.0801 11.647L15.4585 11.0254L14.8633 11.6182L16.0801 12.835L18.2569 10.6462L17.6713 10.063L16.0801 11.647Z"
      class="fill-current"
    />
    <path
      d="M16.0801 15.3237L15.4585 14.7021L14.8633 15.2949L16.0801 16.5117L18.2569 14.3229L17.6713 13.7397L16.0801 15.3237Z"
      class="fill-current"
    />
  </svg>
</template>
